import { AxiosResponse } from 'axios';
import CustomSnackbar from 'components/Common/CustomSnackbar';
import CatchError from 'hooks/CatchError';
import { call, delay, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { deleteType, get, patch, post, putType, uploadImg } from 'utilsNew/request';
import { selectBlogForm, selectOrderBy, selectOrderDir, selectPageNo, selectPageSize, selectSearch } from './selector';
import { actions } from './slice';
import { IData } from './types';
import { blogValidation } from 'components/Common/Validations';

export function* doCreateRequest(action: {
  payload: {
    callback: any;
  };
}) {
  yield delay(500);
  try {
    const form: IData = yield select(selectBlogForm);

    const isValid = blogValidation(form);
    if (!isValid) {
      return;
    }

    yield put(actions.setButtonLoading(true));
    const response: AxiosResponse = yield call(post, `admin/blog/create`, form);
    yield put(actions.setButtonLoading(false));
    if (response && !response.data) {
      CustomSnackbar(response.data.message, 'error');
      return;
    }
    CustomSnackbar(response.data.message, 'success');
    yield call(action.payload.callback());
  } catch (error: any) {
    yield put(actions.setButtonLoading(false));
    CatchError(error);
  }
}

export function* doGetListRequest() {
  yield delay(500);
  try {
    yield put(actions.setLoading(true));
    const pageNo: number = yield select(selectPageNo);
    const pageSize: number = yield select(selectPageSize);
    const searchText: string = yield select(selectSearch);
    const sortColumn: string = yield select(selectOrderBy);
    const sortDir: string = yield select(selectOrderDir);
    const response: AxiosResponse = yield call(
      get,
      `admin/blog/list?pageNo=${pageNo}&pageSize=${pageSize}${searchText.length > 0 ? '&search=' + searchText : ''}${
        sortColumn.length > 0 ? '&orderBy=' + sortColumn : ''
      }${sortDir.length > 0 ? '&orderDirection=' + sortDir : ''}`
    );
    yield put(actions.setLoading(false));
    if (response && !response.data) {
      CustomSnackbar(response.data.message, 'error');
      return;
    }
    yield put(actions.setTotalRow(response.data.data.meta ? response.data.data.meta.total : 0));
    yield put(actions.setList(response.data.data.results));
  } catch (error: any) {
    yield put(actions.setLoading(false));
    CatchError(error);
  }
}
export function* doGetByIdRequest(action: {
  payload: {
    id: string;
  };
}) {
  yield delay(500);
  try {
    yield put(actions.setLoading(true));
    const response: AxiosResponse = yield call(get, `admin/blog/get/${action.payload.id}`);
    yield put(actions.setLoading(false));
    if (response && !response.data) {
      CustomSnackbar(response.data.message, 'error');
      return;
    }
    yield put(actions.setDataInForm(response.data.data));
  } catch (error: any) {
    yield put(actions.setLoading(false));
    CatchError(error);
  }
}
export function* doUpdateRequest(action: {
  payload: {
    callback: any;
  };
}) {
  yield delay(500);
  try {
    const form: IData = yield select(selectBlogForm);

    const isValid = blogValidation(form);
    if (!isValid) {
      return;
    }

    yield put(actions.setButtonLoading(true));
    const response: AxiosResponse = yield call(putType, `admin/blog/update/${form._id}`, form);
    yield put(actions.setButtonLoading(false));
    if (response && !response.data) {
      CustomSnackbar(response.data.message, 'error');
      return;
    }
    CustomSnackbar(response.data.message, 'success');
    yield call(action.payload.callback());
  } catch (error: any) {
    yield put(actions.setButtonLoading(false));
    CatchError(error);
  }
}

export function* doUpdateStatusRequest(action: {
  payload: {
    id: string;
    callback: any;
  };
}) {
  yield delay(500);
  try {
    yield put(actions.setButtonLoading(true));
    const response: AxiosResponse = yield call(patch, `admin/blog/status/update/${action?.payload?.id}`, {});
    yield put(actions.setButtonLoading(false));
    if (response && !response.data) {
      CustomSnackbar(response.data.message, 'error');
      return;
    }
    yield call(action.payload.callback());
  } catch (error: any) {
    yield put(actions.setButtonLoading(false));
    CatchError(error);
  }
}
export function* doDeleteRequest(action: {
  payload: {
    id: string;
    callback: any;
  };
}) {
  yield delay(500);
  try {
    yield put(actions.setButtonLoading(true));
    const response: AxiosResponse = yield call(deleteType, `admin/blog/delete/${action.payload.id}`);
    yield put(actions.setButtonLoading(false));
    if (response && !response.data) {
      CustomSnackbar(response.data.message, 'error');
      return;
    }
    CustomSnackbar(response.data.message, 'success');
    yield call(action.payload.callback());
  } catch (error: any) {
    yield put(actions.setButtonLoading(false));
    CatchError(error);
  }
}

export function* uploadDocumentRequest(action: { payload: { fileName: string; callback: any } }) {
  try {
    const response: AxiosResponse = yield call(post, `admin/blog/signed-url`, {
      fileName: action.payload.fileName
    });
    if (!response.status) {
      CustomSnackbar(response.data.message, 'error');
    }
    yield call(action?.payload?.callback(response.data.data.signedUrl, response.data.data.fileNameWithPrefix));
  } catch (error: any) {
    CatchError(error);
  }
}
export function* UploadImageRequest(action: { payload: { data: any; signedUrl: string; result: any; callback: any } }) {
  yield delay(500);

  try {
    const response: AxiosResponse = yield call(uploadImg, action.payload.signedUrl, action.payload.data, action.payload.result);
    if (!response.status) {
      CustomSnackbar(response.data.message, 'error');
    }
    yield call(action?.payload?.callback());
  } catch (error: any) {
    CatchError(error);
  }
}
export function* BlogRepoSaga() {
  //******file upload */
  yield takeEvery(actions.getSignedUrl, uploadDocumentRequest);
  yield takeEvery(actions.UploadImage, UploadImageRequest);

  ///////
  yield takeLatest(actions.doCreate, doCreateRequest);
  yield takeLatest(actions.doGetList, doGetListRequest);
  yield takeLatest(actions.doGetById, doGetByIdRequest);
  yield takeLatest(actions.doUpdate, doUpdateRequest);
  yield takeLatest(actions.doDelete, doDeleteRequest);
  yield takeLatest(actions.doUpdateStatus, doUpdateStatusRequest);
}
